import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import { FormFileAutoUpload } from 'Common/ReduxForm';
import { addSubmissionFile, downloadFile } from 'Actions/submission';
import { getAttachmentTitle, maxFileSizeValidation } from 'Utils';
import {
    ATTACHMENT_ICON_CLASS_MAP,
    FILE_TYPE_PERMISSION,
    FILE_TYPE_REVIEW,
    MAX_FILE_SIZE,
    COVER_LETTER_EXAMPLE_ID,
    FILE_TYPE_COVER_LETTER,
    REPORT_EXAMPLE_ID,
    FILE_TYPE_MANUSCRIPT_BLIND, ROLE_CHIEF_EDITORIAL,
} from 'Constants';
import { aclDecorator } from 'Decorators';

@connect(null, dispatch => ({
    addSubmissionFile: (id, data) => dispatch(addSubmissionFile(id, data)),
    downloadFile: (fileId, title, saveToLog) => dispatch(downloadFile(fileId, title, saveToLog)),
}))
@reduxForm({
    form: 'submissionFiles',
    enableReinitialize: true,
})
@aclDecorator()
export default class Attachment extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        addSubmissionFile: PropTypes.func.isRequired,
        downloadFile: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        accept: PropTypes.string.isRequired,
        submissionId: PropTypes.number.isRequired,
        upload: PropTypes.bool,
        attachments: PropTypes.object,
        round: PropTypes.number,
        onFileUpload: PropTypes.func.isRequired,
    };

    state = {
        error: null,
        touched: false
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    onChange = (e) => {
        const { addSubmissionFile, submissionId, type, round, onFileUpload } = this.props;
        const data = e.target.files[0];
        const error = maxFileSizeValidation(data);
        this.setState({error, touched: true});
        if (!error) {
            addSubmissionFile(submissionId, {type, data, round});
            if (onFileUpload) onFileUpload();
        }
    };

    handleDownload(event, fileId, fileTitle) {
        event.preventDefault();
        const { downloadFile, is } = this.props;
        downloadFile(fileId, fileTitle, !is(ROLE_CHIEF_EDITORIAL));
    }

    render () {
        const { type, accept, upload, attachments } = this.props;
        const { error, touched } = this.state;
        const attachment = attachments && attachments[type] ? attachments[type] : null;
        const fileTitle = attachment ? getAttachmentTitle(attachment) : '';

        return (
            <div className="fileinput text-center">
                {attachment && (
                    <a className={`fileinput-${ATTACHMENT_ICON_CLASS_MAP[attachment.type]}`} href='#'
                        onClick={ (e) => this.handleDownload(e, attachment.id, fileTitle) } >
                        { fileTitle }
                    </a>
                )}

                {upload && type === FILE_TYPE_REVIEW &&
                    <div className='download-sample-block-wrapper'>
                        <span className='download-sample-text'>
                            {this.context.intl.formatMessage({ id: 'button.submission.download_report' })}
                        </span>
                        <a className='download-sample-link' href="javascript:void(0)"
                            onClick={ (e) => this.handleDownload(e, REPORT_EXAMPLE_ID, this.context.intl.formatMessage({ id: 'files.report_title' })) }
                        >
                            <FormattedMessage id={'button.submission.download_report_link'} />
                        </a>
                    </div>
                }

                {upload && type === FILE_TYPE_COVER_LETTER &&
                    <div className='download-sample-block-wrapper'>
                        <span className='download-sample-text'>
                            {this.context.intl.formatMessage({ id: 'button.submission.download_cover_letter' })}
                        </span>
                        <a className='download-sample-link' href="javascript:void(0)"
                            onClick={ (e) => this.handleDownload(e, COVER_LETTER_EXAMPLE_ID, this.context.intl.formatMessage({ id: 'files.cover_letter_title' })) }
                        >
                            <FormattedMessage id={'button.submission.download_cover_letter_link'} />
                        </a>
                    </div>
                }

                {upload && type === FILE_TYPE_PERMISSION && !attachment &&
                    <div className='download-sample-block-wrapper download-sample-block-big-wrapper'>
                        <span className='download-sample-text'>
                            {this.context.intl.formatMessage({ id: 'button.submission.attach_permission' })}
                        </span>
                    </div>
                }

                {upload && type === FILE_TYPE_MANUSCRIPT_BLIND && !attachment &&
                    <div className='download-sample-block-wrapper download-sample-block-big-wrapper'>
                        <span className='download-sample-text'>
                            {this.context.intl.formatMessage({ id: 'button.submission.attach_manuscript_blind' })}
                        </span>
                    </div>
                }

                {upload &&
                    <div className={'file-upload-wrapper' + (attachment ? '' : ' file-upload-wrapper-with-label')}>
                        <Field
                            name={type}
                            component={ FormFileAutoUpload }
                            type="file"
                            label={type}
                            placeholder={type}
                            attachment={attachment}
                            meta={{error, touched}}
                            labelClassName='file-upload-label'
                            input={{
                                accept,
                                handleChange: this.onChange
                            }}
                        />
                    </div>
                }

                {upload &&
                    this.context.intl.formatMessage({ id: 'files.max_size' }, { max: MAX_FILE_SIZE })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/Attachment.jsx